<template>

	<el-container class="homebox">
		<div class="inter">
			<el-row>
				<div class="section1 home-swiper">

					<div class="middle" style="border-radius: 5px;overflow: hidden;">
						<el-carousel  height="400px"
							style="border-radius: 5px;overflow: hidden;">
							<el-carousel-item v-for="item in banner" :key="item.id">
								<img :src="item.image" />

							</el-carousel-item>
						</el-carousel>
					</div>
					<div class="swiper-count">
						<div class="box">
							<div class="top">
								<h1 class="title">红六游戏</h1>
								<div class="number-title text-fff">
									安全成交
									<span class="number">
										{{homeinit.chengjiao}}
									</span>
									笔交易
								</div>
								<div class="desc">红六游戏使账号交易变得更安全</div>
							</div>
							<div class="count-number">
								<div class="count-number-item count-number-item-left">
									<div class="f12 count-number-title">今日上新</div> <span
										class="f20 fb count-number-number">
										{{homeinit.new}}
									</span>
								</div>
								<div class="count-number-item-c"></div>
								<div class="count-number-item count-number-item-right">
									<div class="f12 count-number-title">商品数量</div> <span
										class="f20 fb count-number-number">
										{{homeinit.num}}
									</span>
								</div>
							</div>
							<div class="btn-group"><a href="/gamelist" class="" title="我要买"><button
										class="btn red-btn">我要买</button></a> <button class="btn blue-btn"
									@click="openMai">我要卖</button>
							</div>
						</div>
						<div class="guide">
							<a class="guide-item" title="寄售指南" @click="openMai"> 寄售指南 </a>
							<a class="guide-item" title="回收指南" @click="openMai"> 回收指南 </a>
						</div>
					</div>

				</div>

				<div class="home_link1 t-flex">
					<a class="item" href="/gamelist">
						<img :src="require(`@/assets/image/home_ic1.jpg`)">
					</a>
					<a class="item">
						<img :src="require(`@/assets/image/home_ic2.jpg`)">
					</a>
					<a class="item">
						<img :src="require(`@/assets/image/home_ic3.jpg`)">
					</a>
				</div>

				<div class="new_section home-left-right">
					<div class="fl">
						<h1 class="home_title home_title2" style="margin-bottom: 20px;"><span>热门游戏</span></h1>
						<ul class="left_game">
							<li v-for="(item, index) in $store.state.gamelist" v-if="index <= 7">
								<router-link :to="{path: 'game', query: {gtype: item.id }}">
									<div class="image">
										<img :src="'http://img.h6ds.com'+item.image3" />
									</div>
									<p>{{item.name}}</p>
								</router-link>
							</li>
						</ul>

					</div>
					<div class="home-right">
						<section class="box-tab p-10 bg-fff">

							<el-tabs v-model="activeName" @tab-click="handleClick">
								<el-tab-pane label="客服验证" name="1">
									<div class="input-search-tab el-input el-input--medium el-input--suffix">
										<input type="text" v-model="neirong1" autocomplete="off" placeholder="请输入客服QQ号码"
											class="el-input__inner"><span class="el-input__suffix"><span
												class="el-input__suffix-inner"><button class="cp red-btn"
													@click="search">搜索</button></span></span>
									</div>
								</el-tab-pane>
								<el-tab-pane label="黑号查询" name="2">
									<div class="input-search-tab el-input el-input--medium el-input--suffix">
										<input type="text" v-model="neirong2" autocomplete="off" placeholder="请输入账号"
											class="el-input__inner"><span class="el-input__suffix"><span
												class="el-input__suffix-inner"><button class="cp red-btn"
													@click="search">搜索</button></span></span>
									</div>
								</el-tab-pane>
							</el-tabs>

						</section>
						<section class="new-question">
							<div class="yellow box box3">
								<div class="title-box">
									<div class="el-image img"><img src="https://oss.pzds.com/imgv2/problem@2x.png"
											class="el-image__inner"></div> <span class="title">业务介绍</span> <a
										href="/helpCenter" class="desc" title="业务介绍">更多</a>
								</div>
								<div class="line"></div>
								<div class="content-box">
									<ul>

										<li class="ellipsis-1" v-if="index <= 5" :title="item.title"
											v-for="(item, index)  in homecms">
											<router-link :to="{path: 'business', query: {id: item.id,index:index }}"
												class="pl-5" :title="item.title">
												{{item.title}}
											</router-link>

										</li>

									</ul>
								</div>
							</div>
						</section>
					</div>
				</div>
			</el-row>


			<!-- <div class="section2">
				<div class="fl">
					<h1 class="home_title"><span>合作主播</span></h1>
					<el-carousel class="zhubo" type="card" height="150px">
						<el-carousel-item v-for="item in zhubo" :key="item.id">
							<img :src="item.image" />

						</el-carousel-item>
					</el-carousel>
				</div>
				<div class="fr"></div>

			</div> -->
			<div class="section3">
				<div class="div1">
					<h1 class="home_title home_title2"><span>顶级账号</span>

					</h1>
					<ul class="dingjiul">
						<li @click="chose(index)" v-if="index <= 10" :class="{'active':dingjiactive == index}"
							v-for="(item, index) in $store.state.gamelist">
							<p>{{item.name}}</p>
						</li>
					</ul>
				</div>
				<div class="div2">
					<ul class="list_img">
						<li v-for="(item, index) in list">
							<router-link :to="{path: 'goodsdetail', query: {id: item.id }}" target="_blank">
								<div class="image">
									<el-image :src="item.image" lazy></el-image>
								</div>
								<div class="text">
									<div class="p1">{{item.title}}</div>
									<div class="flex_box_bt">
										<p class="p3 f14"> <i class="el-icon-view"></i> {{item.views}}</p>
										<p class="price text-F7423F">￥{{item.price}}</p>
									</div>

									<div class="p4">
										区服：{{item.daqu}}/{{item.fuwuqi}}
									</div>
									<div class="p4">
										时间：{{item.updatetime}}
									</div>
									<div class="demo-tag">
										<div class="demo-tag-owner" v-for="(v, k) in item.bq_text" :key="k">
											{{v}}
										</div>
									</div>

								</div>
								<!-- 	<div class="text2">
									<div>
										<p v-for="(item1,index1) in item.bq_text">
											<el-tag effect="dark">
												{{ item1 }}
											</el-tag>
										</p>
									</div>
								</div> -->
							</router-link>
						</li>
					</ul>
				</div>



			</div>


			<div class="section3">
				<div class="div1">
					<h1 class="home_title home_title2"><span>最新上架</span>

					</h1>
					<ul class="dingjiul">
						<li @click="chose2(index)" v-if="index <= 10" :class="{'active':dingjiactive2 == index}"
							v-for="(item, index) in $store.state.gamelist">
							<p>{{item.name}}</p>
						</li>
					</ul>
				</div>
				<div class="div2">
					<ul class="list_img">
						<li v-for="(item, index) in list2">
							<router-link :to="{path: 'goodsdetail', query: {id: item.id }}" target="_blank">
								<div class="image">
									<el-image :src="item.image" lazy></el-image>
								</div>
								<div class="text">
									<div class="p1">{{item.title}}</div>
									<div class="flex_box_bt">
										<p class="p3 f14"> <i class="el-icon-view"></i> {{item.views}}</p>
										<p class="price text-F7423F">￥{{item.price}}</p>
									</div>

									<div class="p4">
										区服：{{item.daqu}}/{{item.fuwuqi}}
									</div>
									<div class="p4">
										时间：{{item.updatetime}}
									</div>
									<div class="demo-tag">
										<div class="demo-tag-owner" v-for="(v, k) in item.bq_text" :key="k">
											{{v}}
										</div>
									</div>

								</div>
								<!-- 	<div class="text2">
									<div>
										<p v-for="(item1,index1) in item.bq_text">
											<el-tag effect="dark">
												{{ item1 }}
											</el-tag>
										</p>
									</div>
								</div> -->
							</router-link>
						</li>
					</ul>
				</div>



			</div>

		</div>
	</el-container>
</template>
<script>
	import {
		Notification,
		Message
	} from 'element-ui'
	export default {
		data() {
			return {

				banner: [],
				gamelist: [],
				zhubo: [],
				dingjiactive: 0,
				dingjiactive2: 0,
				gamalist: [],
				channel: [],
				list: [],
				list2: [],
				activeName: "1",
				neirong1: "",
				neirong2: "",
				homecms: [],
				homeinit:{},


			}
		},
		created: function() {



			this.getBlock('vue首页banner', 'vue_banner', 5);
			// this.getzhubo('直播', 'zhubo', 99);
			this.gethomeCms();
			this.gethomeinit()


			var that = this;

			setTimeout(function() {
				that.$data.gamalist = that.$store.state.gamelist;
				that.$data.channel = that.$data.gamalist[that.$data.dingjiactive];
				// that.$data.channel.id
				// console.log(that.$store.state.gamelist);
				that.getlist(17, 12, function(res) {
					that.list = res.data;
				});
				that.getlist2(17, 12, function(res) {
					that.list2 = res.data;
				});
			}, 1000);



		},
		methods: {
			gethomeinit() {
				var that = this;
				this.rq.requests.post("api/hall/homeinit", {
					id: 46,
				}).then(res => {
					that.homeinit = res.data;
			
			
				}).catch(error => {
			
				})
			},
			gethomeCms() {
				var that = this;
				this.rq.requests.post("api/hall/getchives", {
					id: 46,
				}).then(res => {
					that.homecms = res.data;


				}).catch(error => {

				})
			},
			search() {
				var that = this;
				if (this.activeName == '1') {
					this.rq.requests.post("api/hall/kehu", {
						acc: that.neirong1,
					}).then(res => {

						Message.success({
							message: res.msg,
							duration: 3000
						})
					}).catch(error => {
						Message.closeAll();
						Message.error({
							message: error.msg,
							duration: 3000
						})
					})
				} else {
					this.rq.requests.post("api/hall/heihao", {
						acc: that.neirong2,
					}).then(res => {

						Message.success({
							message: res.msg,
							duration: 3000
						})
					}).catch(error => {
						Message.closeAll();
						Message.error({
							message: error.msg,
							duration: 3000
						})
					})
				}
			},
			handleClick() {

			},
			openMai() {
				this.$parent.$refs['sell'].visible = true
			},
			chose(index) {
				var that = this;
				that.dingjiactive = index;

				var channel = that.gamalist[index];

				that.getlist(that.gamalist[index].id, 12, function(res) {
					that.list = res.data;
				});
			},
			chose2(index) {
				var that = this;
				that.dingjiactive2 = index;


				that.getlist2(that.gamalist[index].id, 12, function(res) {
					that.list2 = res.data;
				});
			},
			getBlock(type, name, row) {
				var that = this;
				this.rq.requests.post("api/hall/getBlock", {
					type: type,
					name: name,
					row: row
				}).then(res => {
					that.$data.banner = res.data;
				}).catch(error => {

				})
			},

			getzhubo(type, name, row) {
				var that = this;
				this.rq.requests.post("api/hall/getBlock", {
					type: type,
					name: name,
					row: row
				}).then(res => {
					that.$data.zhubo = res.data;
				}).catch(error => {

				})
			},

			getlist(id, num, callback) {
				var that = this;

				var post = {};
				post.channel = id;
				post.limit = num;
				post.flag = "top"
				post.addon = 'price,daqu,bq';
				this.rq.requests.post("api/hall/getchiveslist", post).then(res => {
					callback(res);
				}).catch(error => {

				})
			},
			getlist2(id, num, callback) {
				var that = this;

				var post = {};
				post.channel = id;
				post.limit = num;
				post.addon = 'price,daqu,bq';
				this.rq.requests.post("api/hall/getchiveslist", post).then(res => {
					callback(res);
				}).catch(error => {

				})
			},


		}
	}
</script>